import { Directive, ElementRef, Inject, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DpadScrollableHorizontalDirective } from '../lib/proto-dpad-navigation/directives/dpad-scrollable-horizontal.directive';

@Directive({
    selector: '[lazyLoad]'
})
export class LazyLoadDirective implements OnDestroy{

    @Input() lazyLoad = false;

    observer: IntersectionObserver;

    constructor(private view: ViewContainerRef,
                private template: TemplateRef<any>,
                @Inject(DOCUMENT) private readonly document: Document,
                private readonly elementRef: ElementRef) {

        const options: IntersectionObserverInit = {
            root: this.document.body,
            rootMargin: '10px',
            threshold: 0
        }

        const intersectionCallback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio === 1) {
                    this.view.createEmbeddedView(this.template);
                    this.observer?.disconnect();
                }
            })
        }

        this.observer = new IntersectionObserver(intersectionCallback, options);

        const target = this.elementRef.nativeElement.parentElement;
        target && this.observer?.observe(target);
    }

    ngOnDestroy() {
        this.observer?.disconnect();
    }

}
